import React from 'react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/content';
export function PainGrid() {
  return <section className="w-full bg-cream px-5 pb-24 sm:pb-32" data-id="element-156" data-mp="1zgqaara485db">
      <div className="mx-auto w-full max-w-[1120px]" data-id="element-157" data-mp="1uogq7rvolziy">
        <Reveal data-id="element-158" data-mp="1umvtpwpt46ig">
          <h2 className="mx-auto max-w-3xl text-center font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-navy sm:text-5xl" data-id="element-159" data-mp="1umm4wcgi05ec">
            Kender du dig selv i de her situationer?
          </h2>
        </Reveal>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-160" data-mp="1goebgeio7m7x">
          {painPoints.map((point, index) => <Reveal as="li" key={point.number} delay={index % 3 * 0.06} data-id="element-161" data-mp="1bqvwo7hz2cs0" data-mpi={index}>
              <article className="flex h-full flex-col rounded-card border border-line bg-white p-7 shadow-card" data-id="element-162" data-mp="17or6jiqqfya4">
                <p aria-hidden="true" className="font-display text-5xl font-bold leading-none text-transparent [-webkit-text-stroke:1.5px_#C8102E]" data-id="element-163" data-mp="36458w71wkcdy">
                  {point.number}
                </p>
                <h3 className="mt-5 font-display text-2xl font-bold uppercase leading-tight tracking-tight text-navy" data-id="element-164" data-mp="3gbg0z2zs33ej">
                  {point.title}
                </h3>
                <p className="mt-auto pt-3 text-base leading-relaxed text-muted" data-id="element-165" data-mp="379zs4zom39cf">
                  {point.body}
                </p>
              </article>
            </Reveal>)}
        </ul>

        <Reveal delay={0.12} data-id="element-166" data-mp="2uqg69h6o3rj">
          <p className="mx-auto mt-12 max-w-2xl text-center text-lg font-medium leading-relaxed text-red" data-id="element-167" data-mp="7ta60kywdzp6">
            Det er ikke, fordi du er en dårlig træner. Det er, fordi ingen har lagt
            sæsonen for dig.
          </p>
        </Reveal>
      </div>
    </section>;
}